var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.filepath
        ? _c(
            "v-card",
            {
              staticClass: "elevation-10",
              attrs: { id: "player-controls" },
              on: { mousedown: _vm.mouseDown }
            },
            [
              _c(
                "v-card-title",
                { staticClass: "pa-0 pl-2" },
                [
                  _c("v-icon", { attrs: { large: "", color: "color" } }, [
                    _vm._v("drag_indicator")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "px-2" }, [
                    _vm._v(_vm._s(_vm.filepath))
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "ma-O",
                      attrs: { large: "", flat: "", icon: "", color: "color" },
                      on: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [_c("v-icon", { attrs: { large: "" } }, [_vm._v("close")])],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "pa-0" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "tc-btn display-3",
                      attrs: { block: "", flat: "", color: "color" },
                      on: {
                        click: function($event) {
                          return _vm.copyTc(_vm.timecode)
                        }
                      }
                    },
                    [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(_vm.timecode) + "\n\t\t\t\t"
                      ),
                      _c(
                        "span",
                        { staticClass: "caption ml-1 pa-1 primary darken-1" },
                        [_vm._v("Alt + T")]
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "pa-0" },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  !_vm.player
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            flat: "",
                            icon: "",
                            large: "",
                            color: "color",
                            loading: _vm.loading
                          },
                          on: {
                            click: function($event) {
                              return _vm.start()
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { large: "" } }, [
                            _vm._v("play_arrow")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.player
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            flat: "",
                            icon: "",
                            large: "",
                            color: "color",
                            loading: _vm.loading
                          },
                          on: {
                            click: function($event) {
                              return _vm.play()
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { large: "" } }, [
                            _vm._v("play_arrow")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.player
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            flat: "",
                            icon: "",
                            large: "",
                            color: "color"
                          },
                          on: {
                            click: function($event) {
                              return _vm.pause()
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { large: "" } }, [
                            _vm._v("pause")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.player
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            flat: "",
                            icon: "",
                            large: "",
                            color: "color"
                          },
                          on: {
                            click: function($event) {
                              return _vm.stop()
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { large: "" } }, [
                            _vm._v("stop")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.player
                    ? _c(
                        "v-btn",
                        {
                          attrs: {
                            flat: "",
                            icon: "",
                            large: "",
                            color: "color"
                          },
                          on: {
                            click: function($event) {
                              return _vm.capture()
                            }
                          }
                        },
                        [
                          _c("v-icon", { attrs: { large: "" } }, [
                            _vm._v("add_photo_alternate")
                          ])
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-spacer")
                ],
                1
              ),
              _vm._v(" "),
              _vm.captures.length
                ? _c(
                    "v-card-actions",
                    {
                      staticClass: "pa-0",
                      staticStyle: { "max-height": "350px", overflow: "auto" }
                    },
                    [
                      _c(
                        "v-container",
                        {
                          staticClass: "pa-1",
                          attrs: { "grid-list-sm": "", fluid: "" }
                        },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            _vm._l(_vm.captures, function(capture, i) {
                              return _c(
                                "v-flex",
                                { key: "capture_" + i, attrs: { xs4: "" } },
                                [
                                  _c(
                                    "v-card",
                                    { attrs: { flat: "", tile: "" } },
                                    [
                                      _c("v-img", {
                                        attrs: {
                                          src: capture.image,
                                          title: capture.timecode,
                                          height: "100px"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.captures.length
                ? _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ma-0 text-none",
                          attrs: { flat: "", small: "", color: "color" },
                          on: {
                            click: function($event) {
                              return _vm.downloadCaptures()
                            }
                          }
                        },
                        [
                          _c("v-icon", [_vm._v("download")]),
                          _vm._v("\n\t\t\t\tTélécharger les captures\n\t\t\t")
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ac1dc6c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ac1dc6c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./build/scramble/app-loader.js!./src/components/switch_player.vue
// module id = null
// module chunks = 